import { NgModule } from '@angular/core';
import { FiAppearanceStartPageEditSelectLayoutComponent } from './select-layout/select-layout.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiDisableLinksModule } from '../../../shared/fi-directives/disable-links/disable-links.module';
import { FiAppearanceStartPageEditLayoutComponent } from './layout/layout.component';
import { WidgetModule } from '../../../widget/widget.module';
import { DndModule } from 'ngx-drag-drop';
import { FiAppearanceStartPageEditComponent } from './edit.component';
import { UtilitiesModule } from '../../../utilities/utilities.module';
import { FiAppearanceAvailableWidgetsListModule } from '../../available-widgets-list/available-widgets-list.module';
import { FiAppearanceWidgetSettingsWrapModule } from '../../widget-settings-wrap/widget-settings-wrap.module';
import { FiAppearanceTrashBinModule } from '../../trash-bin/trash-bin.module';
import { FormsModule } from '@angular/forms';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatButtonModule } from '@angular/material/button';
import { FiOnboardingHomePageModule } from '@fi-app/fi-onboarding/fi-onboarding-home-page/fi-onboarding-home-page.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiDisableLinksModule,
        WidgetModule,
        DndModule,
        UtilitiesModule,
        FiAppearanceAvailableWidgetsListModule,
        FiAppearanceWidgetSettingsWrapModule,
        FiAppearanceTrashBinModule,
        FormsModule,
        FiPageHeaderModule,
        SelectSearchModule,
        MatButtonModule,
        FiOnboardingHomePageModule,
    ],
    declarations: [
        FiAppearanceStartPageEditSelectLayoutComponent,
        FiAppearanceStartPageEditLayoutComponent,
        FiAppearanceStartPageEditComponent,
    ],
    exports: [FiAppearanceStartPageEditComponent],
})
export class FiAppearanceStartPageEditModule {}
